import React from 'react'
import classNames from 'classnames'

const InputTextarea = ({ error, ...props }) => (
  <div className="control">
    <textarea
      className={classNames('textarea', { 'is-danger': error })}
      type="textarea"
      {...props}
    />
    <p className={classNames('help', { 'is-danger': error })}> {error} </p>
  </div>
)

export default InputTextarea


// WEBPACK FOOTER //
// ./src/components/views/widgets/InputTextarea.js